module.exports = __webpack_public_path__ + "static/media/github-background.0b819d63.svg";